import Container from '../components/ui/Container/Container';
import PageHeading from '../components/ui/PageHeading/PageHeading';
import ReservationsList from '../components/Reservations/ReservationsList';

const ReservationsPage: React.FC = () => {
  return (
    <>
      <PageHeading>Bookings</PageHeading>
      <Container>
        <ReservationsList />
      </Container>
    </>
  )
}

export default ReservationsPage;